import React, { useState, useRef, useEffect } from 'react';
import scanner from './images/sacnner.jpg';
import axios from 'axios';

import service1 from './images/service1.jpeg';
import service2 from './images/service2.jpeg';
import eventbanner from './images/EventBanner.jpg';
import vstqr from './images/visitorQRCode.png'
import customamount from './images/customamount.jpeg';
import evenpayment from './images/eventpaymrnt.jpeg';

import ev2 from './images/evbg2.jpeg'
interface chapterstruc{
  id:number;
  name:string;
}

interface UserStructure {
  profile: string;
  id: number;
  name: string;
  email: string;
  delete: number;
  role:string;
  designation:string;
  company_name:string;
  Facebook:string;
  Linkedin:string;
  point:number;
  number:number;
}
const Sticky = () => {
  const api = process.env.REACT_APP_API_URL as string;

  const [isExpressModalOpen, setExpressModalOpen] = useState<boolean>(false);
  const [isVisitorModalOpen, setVisitorModalOpen] = useState<boolean>(false);
  const [isResistationModalOpen, setRegistationModalOpen] = useState<boolean>(false);


  const [selectedFacility, setSelectedFacility] = useState<string | null>("800");
  const [selectedTshirtSize, setselectedTshirtSize] = useState<string | null>(null);
  const [selectedFile, setSelectedFile] = useState<String | null>(null); 
const [userDetails, setuserDetails] = useState<UserStructure[]>([]);

  
    useEffect(() => {
      const fetchData = async () => {
        try {
          const response = await axios.get<UserStructure[]>(
            `${api}/auth/allusersinfo`
          );
  
          setuserDetails(response.data);
        } catch (error) {
          console.error("user Not Found:", error);
        }
      };
  
      fetchData();
    }, []);
  const handleTshirtSizeChange = (e:any) => {
    setselectedTshirtSize(e.target.value);
  };

  const handleFacilityChange = (e:any) => {
    setSelectedFacility(e.target.value);
  };
  
  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files[0]) {
      // setSelectedFile(event.target.files[0]);
    }

    const file = event.target.files?.[0] || null;
    setSelectedFile(file ? file.name : null);
  };

  // Create refs for both modals
  const expressModalRef = useRef<HTMLDivElement>(null);
  const visitorModalRef = useRef<HTMLDivElement>(null);

  // Handle outside click for Express Interest Modal
const[chapterdata, setChapterdata] = useState<chapterstruc[]>([]);

  useEffect (()=>{
    const fetch = async ()=>{
        try{

            const response = await axios.get(`${api}/auth/chapter`);
            setChapterdata(response.data.data);

        }
        catch(error){
   
            //console.log('error fetching point', error);
        }
    }
    fetch();
},[])

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (expressModalRef.current && !expressModalRef.current.contains(event.target as Node)) {
        setRegistationModalOpen(false);
      }
    };

    if (isResistationModalOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isResistationModalOpen]);


  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (expressModalRef.current && !expressModalRef.current.contains(event.target as Node)) {
        setExpressModalOpen(false);
      }
    };

    if (isExpressModalOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isExpressModalOpen]);

  // Handle outside click for Visitor Registration Modal
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (visitorModalRef.current && !visitorModalRef.current.contains(event.target as Node)) {
        setVisitorModalOpen(false);
      }
    };

    if (isVisitorModalOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isVisitorModalOpen]);

  // Handle Express Interest form submission
const handleExpressSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
  event.preventDefault();

  // Example form data collection
  const formData = new FormData(event.currentTarget);
  const data = {
    fullName: formData.get('fullName'),
    email: formData.get('email'),
    dob: formData.get('dob'),
    businessName: formData.get('businessName'),
    category: formData.get('category'),
    mobile: formData.get('mobile'),
  };

  // console.log('data of express',data);

  try {
    const response = await axios.post(`${api}/auth/express-interest`, data, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    
    if (response.status === 200 || response.status === 201) {
      setExpressModalOpen(false);
      // console.log('Express Interest form submitted successfully');
    } else {
      console.error('Failed to submit Express Interest form');
    }
  } catch (error) {
    console.error('Error submitting Express Interest form:', error);
  }
  

};

// Handle Visitor Registration form submission
const handleVisitorSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
  event.preventDefault();

  // Example form data collection
  const formData = new FormData(event.currentTarget);
  const data = {
    profilePicture: formData.get('profilePicture'), // File object
    fullName: formData.get('fullName'),
    mobile: formData.get('mobile'),
    invitedBy: formData.get('invitedBy'),
    companyName: formData.get('companyName'),
    address: formData.get('address'),
    category: formData.get('category'),

    // Payment checkboxes — collect all selected values
    paymentDone: formData.getAll('paymentDone'), // Returns an array like ["PayTM", "GPay"]

    paymentDate: formData.get('paymentDate'),
    transactionId: formData.get('transactionId'),
    paymentScreenshot: formData.get('paymentScreenshot'), // File object
  };


  try {
    const response = await axios.post(
      `${api}/auth/visitor-registration`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );

    if (response.status >= 200 && response.status < 300) {
      setVisitorModalOpen(false);
    } else {
      console.error(
        'Failed to submit Visitor Registration form:',
        response.data.message || 'Unknown error'
      );
    }
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.error(
        'Error submitting Visitor Registration form:',
        error.response?.data?.message || error.message
      );
    } else {
      console.error('Unexpected error:', error);
    }
  }

  setVisitorModalOpen(false);
};

const handleRegistrationSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
  event.preventDefault();

  // Example form data collection
  const formData = new FormData(event.currentTarget);
  const data = {
    name: formData.get('name'),
    chaptId: formData.get('chaptId'),
    businessName: formData.get('businessName'),
    category: formData.get('category'),
    mobile: formData.get('mobile'),
  transitionId: formData.get('transitionId'),
  facility: selectedFacility,
  address:formData.get('address'),
  city: formData.get('city'),
  role: formData.get('role'),
  deals: formData.get('deals'),
  pincode: formData.get('pincode'),
  suggestionQuestion:formData.get('suggestionQuestion'),
  email:formData.get('email'),
  whatsappNumber:formData.get('whatappnumber'),
  profile:selectedFile,
  tSize: selectedTshirtSize,





    
  };

  // console.log('data , ',data);

  try {
    const response = await axios.post(`${api}/auth/event-registration`, data, {
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (response.status >= 200 && response.status < 300) {
      // console.log('Visitor Registration form submitted successfully');
      setRegistationModalOpen(false)
    } else {
      console.error('Failed to submit Visitor Registration form:', response.data.message || 'Unknown error');
    }
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.error('Error submitting Visitor Registration form:', error.response?.data?.message || error.message);
    } else {
      console.error('Unexpected error:', error);
    }
  }

  setVisitorModalOpen(false);
};


  return (
    <div className="!w-screen bg-white p-0 hidden lg:block">
      <div className="w-screen">
        {/* Button Section */}
        <div className="h-[560px] fixed flex justify-center gap-[168px] flex-col -right-20 items-end z-[10000000000]">
        <section
            className="w-[193px] hidden h-[36px] text-[16px] font-normal rotate-90 bg-lightblue text-textred  flex items-center justify-center rounded cursor-pointer"
            onClick={() => setRegistationModalOpen(!isResistationModalOpen)}
          >
            Event Registration
          </section>
          <section
            className="w-[193px] h-[36px] text-[16px] font-normal rotate-90 bg-lightblue text-textyellow flex items-center justify-center rounded cursor-pointer"
            onClick={() => setExpressModalOpen(!isExpressModalOpen)}
          >
            Express Interest
          </section>
          <section
            className=" w-[193px] h-[36px] text-[16px] font-normal rotate-90 bg-lightblue text-green-400 flex items-center justify-center rounded cursor-pointer"
            onClick={() => setVisitorModalOpen(!isVisitorModalOpen)}
          >
            Visitor Registration
          </section>
        </div>

 {/* Express Interest Modal */}
 {isResistationModalOpen && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white p-6 rounded-lg w-[50%] h-[94%] overflow-y-auto" ref={expressModalRef}>
              <img src = {ev2} className='w-[96%]' />
              <h2 className="text-xl font-bold mb-4">Event Registration Form</h2>
              <form
  onSubmit={handleRegistrationSubmit}
  className="max-w-4xl mx-auto bg-white p-6 rounded-lg shadow-md grid grid-cols-1 gap-6 md:grid-cols-2"
 
>
  <label className="block">
    <span className="block font-medium text-gray-700">Full Name:</span>
    <input
      type="text"
      className="w-full border border-gray-300 p-2 rounded mt-1 focus:ring-2 focus:ring-blue-500"
      placeholder="Enter Your Name"
      name="name"
      required
    />
  </label>
 <label className="block">
    <span className="block font-medium text-gray-700">Email Id:</span>
    <input
      type="email"
      className="w-full border border-gray-300 p-2 rounded mt-1 focus:ring-2 focus:ring-blue-500"
      name="email"
      placeholder="Enter Email Address"
      required
    />
  </label>
   <label className="block">
    <span className="block font-medium text-gray-700">Mobile number:</span>
    <input
      type="tel"
      className="w-full border border-gray-300 p-2 rounded mt-1 focus:ring-2 focus:ring-blue-500"
      name="mobile"
      placeholder="Enter Mobile Number"
      required
    />
  </label>
   <label className="block">
    <span className="block font-medium text-gray-700">City:</span>
    <input
      type="text"
      className="w-full border border-gray-300 p-2 rounded mt-1 focus:ring-2 focus:ring-blue-500"
      name="city"
      placeholder="Enter City Name"
      required
    />
  </label>
  <label className="block">
    <span className="block font-medium text-gray-700">Pincode:</span>
    <input
      type="text"
      className="w-full border border-gray-300 p-2 rounded mt-1 focus:ring-2 focus:ring-blue-500"
      name="pincode"
      placeholder="Enter Pincode"
      required
    />
  </label>
  <label className="block">
    <span className="block font-medium text-gray-700">Business / Organization Name:</span>
    <input
      type="text"
      className="w-full border border-gray-300 p-2 rounded mt-1 focus:ring-2 focus:ring-blue-500"
      name="businessName"
      placeholder="Enter Organization Name"
      required
    />
  </label>
  <label className="block">
    <span className="block font-medium text-gray-700">Business Classification / Category:</span>
    <input
      type="text"
      className="w-full border border-gray-300 p-2 rounded mt-1 focus:ring-2 focus:ring-blue-500"
      name="category"
      placeholder="Enter Classification Name"
      required
    />
  </label>
  
  <label className="block">
    <span className="block font-medium text-gray-700">Upload Payment</span>
    <input
      type="file"
      className="w-full border border-gray-300 p-2 rounded mt-1 focus:ring-2 focus:ring-blue-500"
      name="profile"
      onChange={handleFileChange}
      placeholder="choose your profile"
      
    />
  </label>



  <label className="block">
  <span className="block font-medium text-gray-700">Paid Amount:</span>
  <div className="flex gap-4 mt-2">
    <label className="flex items-center">
      <input
        type="radio"
        name="facility"
        value="800"
        onChange={handleFacilityChange}
        checked={selectedFacility === '800'}
        className="form-radio h-5 w-5 text-blue-600 border-gray-300 rounded focus:ring-2 focus:ring-blue-500"
      />
      <span className="ml-2 text-gray-700">Rs. 800 /-</span>
    </label>
    <label className="flex items-center">
      <input
        type="radio"
        name="facility"
        value="1000"
        onChange={handleFacilityChange}
        checked={selectedFacility === '1000'}
        className="form-radio h-5 w-5 text-blue-600 border-gray-300 rounded focus:ring-2 focus:ring-blue-500"
      />
      <span className="ml-2 text-gray-700">Rs. 1000  /-</span>
    </label>
       <label className="flex items-center">
      <input
        type="radio"
        name="facility"
        value="RMBJaipurMember"
        onChange={handleFacilityChange}
        checked={selectedFacility === 'RMBJaipurMember'}
        className="form-radio h-5 w-5 text-blue-600 border-gray-300 rounded focus:ring-2 focus:ring-blue-500"
      />
      <span className="ml-2 text-gray-700">RMB Jaipur Member</span>
    </label>
  </div>
</label>


  {selectedFacility === '800' && (
    <div className="col-span-2 mt-4 flex">
      
      
      <img
        src={evenpayment}
        alt="First Facility"
        className="mt-2 w-[190px] h-auto max-w-sm mx-auto rounded-lg shadow-md flex justify-end items-end"
      />
    </div>
  )}
  {selectedFacility === '1000' && (
    <div className="col-span-2 mt-4 flex">
     
      <img
        src={evenpayment}
        alt="Second Facility"
        className="mt-2 w-[190px] h-auto max-w-sm mx-auto rounded-lg shadow-md flex justify-end items-end"
      />
    </div>
  )}

  <label className="block">
    <span className="block font-medium text-gray-700">Transition / UTR Id:</span>
    <input
      type="text"
      className="w-full border border-gray-300 p-2 rounded mt-1 focus:ring-2 focus:ring-blue-500"
      name="transitionId"
      placeholder="Enter Your Transition / UTR Id"
      
    />
  </label>

  <div className="col-span-2 flex justify-start gap-2 mt-6">
    <button
      className="bg-blue-600 hover:bg-blue-700 text-white rounded w-full sm:w-auto text-lg font-medium h-[46px] px-4"
      type="submit"
    >
      Submit
    </button>
    <button
      className="bg-red-600 hover:bg-red-700 text-white rounded w-full sm:w-auto text-lg font-medium h-[46px] px-4 ml-2"
      type="button"
      onClick={() => setRegistationModalOpen(false)}
    >
      Close
    </button>
  </div>
</form>


            </div>
          </div>
        )}

        {/* Express Interest Modal */}
        {isExpressModalOpen && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white p-6 rounded-lg w-[50%]" ref={expressModalRef}>
              <h2 className="text-xl font-bold mb-4">Express Interest Form</h2>
              <form onSubmit={handleExpressSubmit}>
                <label className="block mb-2">
                  Full Name:
                  <input type="text" className="w-full border p-2 rounded mt-1" name='fullName' required />
                </label>
                <label className="block mb-2">
                  Email:
                  <input type="email" className="w-full border p-2 rounded mt-1" name='email' required />
                </label>
                <label className="block mb-2">
                  DOB:
                  <input type="date" className="w-full border p-2 rounded mt-1" name='dob' required />
                </label>
                <label className="block mb-2">
                  Business / Organization Name:
                  <input type="text" className="w-full border p-2 rounded mt-1" name='businessName' required />
                </label>
                <label className="block mb-2">
                  Business Classification / Category:
                  <input type="text" className="w-full border p-2 rounded mt-1" name='category' required />
                </label>
                <label className="block mb-2">
                  Mobile No.:
                  <input type="tel" className="w-full border p-2 rounded mt-1" name='mobile' required />
                </label>
                <button
                  className="bg-[#02256D] rounded w-[110px] text-[#F1F4F9] font-[16px] h-[46px]"
                  type="submit"
                >
                  Submit
                </button>
                <button
                  className="bg-textred ml-2 rounded w-[110px] text-[#F1F4F9] font-[16px] h-[46px]"
                  type="button"
                  onClick={() => setExpressModalOpen(false)}
                >
                  Close
                </button>
              </form>
            </div>
          </div>
        )}

        {/* Visitor Registration Modal */}
      {isVisitorModalOpen && (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div
      className="bg-white p-6 rounded-lg w-[95%] md:w-[80%] lg:w-[60%] max-h-screen overflow-y-auto"
      ref={visitorModalRef}
    >
      <h2 className="text-xl font-bold mb-4">Visitor Registration Form</h2>
      <form onSubmit={handleVisitorSubmit}>
        {/* Upload Profile Picture */}
        <div className="mb-4">
          <label className="block">
            Upload Profile Picture:
            <input
              type="file"
              name="profilePicture"
              className="w-full border p-2 rounded mt-1"
              accept="image/*"
              required
            />
          </label>
        </div>

        {/* Full Name & Mobile No */}
        <div className="flex flex-col md:flex-row gap-4 mb-4">
          <label className="w-full md:w-1/2">
            Full Name:
            <input type="text" className="w-full border p-2 rounded mt-1" name="fullName" required />
          </label>
          <label className="w-full md:w-1/2">
            Mobile No.:
            <input type="tel" className="w-full border p-2 rounded mt-1" name="mobile" required />
          </label>
        </div>

        {/* Invited By & Company Name */}
        <div className="flex flex-col md:flex-row gap-4 mb-4">
          <label className="w-full md:w-1/2">
            Invited By:
            <select name="invitedBy" className="w-full border p-2 rounded mt-1" required>
              <option value="">Select User</option>
             {userDetails
  ?.filter(
    user =>
      user.name?.toLowerCase() !== "rajnish" &&
      user.name?.toLowerCase() !== "admin"
  )
  .map(user => (
    <option key={user.id} value={user.id}>
      {user.name}
    </option>
  ))}
            </select>
          </label>
          <label className="w-full md:w-1/2">
            Company Name:
            <input type="text" className="w-full border p-2 rounded mt-1" name="companyName" required />
          </label>
        </div>

        {/* Business Classification */}
        <div className="flex flex-col md:flex-row gap-4 mb-4">
           <label className="w-full md:w-1/2">
            Address:
            <input type="text" className="w-full border p-2 rounded mt-1" name="address" required />
          </label>
          <label className="w-full md:w-1/2">
            Business Classification / Category:
            <input type="text" className="w-full border p-2 rounded mt-1" name="category" required />
          </label>
        </div>

        {/* Payment Done (Checkboxes) */}
        {/* Payment Done (Radio Buttons) */}
<div className="mb-4">
  <label className="block mb-1">Payment Done:</label>
  <div className="flex flex-col sm:flex-row gap-4">
    
    <label className="flex items-center">
      <input type="radio" name="paymentDone" value="Guests" className="mr-2" />
      For New Guests 600/-
    </label>
  </div>
</div>


        {/* Payment Date, Transaction ID, Payment Screenshot */}
        <div className="flex flex-col md:flex-row gap-4 mb-4">
          <label className="w-full md:w-1/3">
            Payment Date:
            <input type="date" className="w-full border p-2 rounded mt-1" name="paymentDate" required />
          </label>
          <label className="w-full md:w-1/3">
            Transaction ID:
            <input
              type="text"
              className="w-full border p-2 rounded mt-1"
              name="transactionId"
              placeholder="Enter Transaction ID"
              required
            />
          </label>
          <label className="w-full md:w-1/3">
            Upload Payment Screenshot:
            <input
              type="file"
              name="paymentScreenshot"
              className="w-full border p-2 rounded mt-1"
              accept="image/*"
              required
            />
          </label>
        </div>

        <div className="mb-6 text-center">
  <img
     src={vstqr} // Replace with your actual QR image path
    alt="QR Code"
    className="mx-auto w-40 h-40 object-contain mb-4"
  />
  <p className="text-sm font-medium text-gray-700">Venue Fee: ₹600/-</p>
  {/* <p className="text-sm font-medium text-gray-700">₹800/- (after 15 Aug 2025)</p> */}
</div>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-2 justify-end mt-6">
          <button
            className="bg-[#02256D] rounded text-white font-medium px-6 py-2 hover:bg-[#011e5a] transition"
            type="submit"
          >
            Submit
          </button>
          <button
            className="bg-red-600 rounded text-white font-medium px-6 py-2 hover:bg-red-700 transition"
            type="button"
            onClick={() => setVisitorModalOpen(false)}
          >
            Close
          </button>
        </div>
      </form>
    </div>
  </div>
)}



      </div>
    </div>
  );
};

export default Sticky;
